import React, { useCallback, useMemo } from 'react'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'

import StepForm from '../../../../../../features/components/Forms/StepForm'
import SpecificCampaignsMarginStep from '../../Steps/SpecificCampaignsMarginStep'
import MarginFeeStep from '../../Steps/MarginFeeStep'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'

import { createMarginOverride, clearCreateMarginOverride } from '../../../../../../modules/actions/margins'
import {
  createMarginOverrideErrorSelector,
  createMarginOverrideIsLoadingSelector,
  createMarginOverrideWasCreatedSelector
} from '../../../../../../modules/selectors/margins'
import { selectedPartnershipIdSelector } from '../../../../../../modules/selectors/partnerships'

import { initialValues } from '../../fields'
import { validationSchema } from './validation'
import { transformValuesToBE } from './formatters'
import { MARGIN_CREATE } from '../../../../../../constants/forms'

const MarginOverrideRoute = ({ formatOption, FormRouteSelector, eventSourceStep, ...formProps }) => {
  const dispatch = useDispatch()

  const selectedPartnershipId = useSelector(selectedPartnershipIdSelector)
  const marginsOverrideWasCreated = useSelector(createMarginOverrideWasCreatedSelector)

  const onSubmit = useCallback(
    values => {
      dispatch(createMarginOverride(transformValuesToBE(values, selectedPartnershipId)))
    },
    [dispatch, selectedPartnershipId]
  )

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const steps = useMemo(
    () => [
      {
        component: FormRouteSelector,
        show: true
      },
      {
        component: <SpecificCampaignsMarginStep />,
        show: true
      },
      {
        component: <MarginFeeStep />,
        show: true
      }
    ],
    [FormRouteSelector]
  )

  const clearCreateMarginHandler = () => {
    dispatch(clearCreateMarginOverride())
  }

  return (
    <StepForm
      steps={steps}
      formik={purifiedFormik}
      formName={MARGIN_CREATE}
      {...formProps}
      // this allow to clearCreateMargins on error
      clearSubmitHandler={clearCreateMarginHandler}
      successSubmit={marginsOverrideWasCreated}
      errorSelector={createMarginOverrideErrorSelector}
      isLoadingSelector={createMarginOverrideIsLoadingSelector}
    />
  )
}

export default MarginOverrideRoute
